import BookingsCountLabel from 'components/Common/Labels/BookingsCountLabel'
import DatesAvailable2027CampaignLabel, { hasDatesAvailable2027CampaignTag } from 'components/Common/Labels/DatesAvailable2027CampaignLabel'
import WorldTravelDayCampaignLabel, { hasWorldTravelDayCampaignTag } from 'components/Common/Labels/WorldTravelDayCampaignLabel'
import OfferLabels from 'components/Common/Labels/OfferLabels'
import PerfectForGroupsLabel from 'components/Common/Labels/PerfectForGroupsLabel'
import OfferBadgeLabel from 'components/Common/OfferBadgeLabel/OfferBadgeLabel'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import type { ComponentProps } from 'react'
import { shouldShowPerfectForGroupsLabel } from 'lib/charterFlights/kidsFlyFreeUtils'
import LuxPlusMonthOfferPageNotice from 'takeovers/luxPlusMonthTakeover/components/LuxPlusMonthOfferPageNotice'

type InheritedOfferLabelsProps = ComponentProps<typeof OfferLabels>

interface Props extends InheritedOfferLabelsProps {
  offer: App.Offer | App.OfferSummary
  showBadge?: boolean
}

function OfferPageLabelGroup(props: Props) {
  const {
    offer,
    showBadge,
    ...offerLabelProps
  } = props

  const bookings = offer.stats.booked

  return <LabelGroup>
    {hasWorldTravelDayCampaignTag(offer.campaignTags) && <WorldTravelDayCampaignLabel />}
    {hasDatesAvailable2027CampaignTag(offer.campaignTags) && <DatesAvailable2027CampaignLabel />}
    {shouldShowPerfectForGroupsLabel(offer) && <PerfectForGroupsLabel />}
    <OfferLabels
      {...offerLabelProps}
      offer={offer}
      onOfferPage
    />
    <BookingsCountLabel bookings={bookings} threshold="offer" />
    {showBadge && !!offer.badge && <OfferBadgeLabel badge={offer.badge} />}
    <LuxPlusMonthOfferPageNotice offer={offer} />
  </LabelGroup>
}

export default OfferPageLabelGroup
